import React from "react";
import Link from "@mui/material/Link";

const CustomTextWithLink: React.FC<{
    fullText: string,
    link: string,
    linkLabelKey: string
}> = ({ fullText, link, linkLabelKey }) => {
    const parts = fullText.split(new RegExp(`(${linkLabelKey})`, "g"));

    return (
        <React.Fragment>
            {parts.map((part, index) =>
                part.toLowerCase() === linkLabelKey.toLowerCase() ? (
                    <Link key={index} href={link} target="_blank" color="textPrimary">
                        {part}
                    </Link>
                ) : (
                    part
                )
            )}
        </React.Fragment>
    );
};

export default CustomTextWithLink;